import raf from 'raf';
import getScroll from './getScroll';
import { easeInOutCubic } from './easings';
export default function scrollTo(to, options = {}) {
    const { getContainer = () => window, callback, duration = 450, top = true } = options;
    const container = getContainer();
    const scroll = getScroll(container, top);
    const startTime = Date.now();
    const frameFunc = () => {
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScroll = easeInOutCubic(time > duration ? duration : time, scroll, to, duration);
        if (top) {
            if (container === window) {
                window.scrollTo(window.pageXOffset, nextScroll);
            }
            else {
                container.scrollTop = nextScroll;
            }
        }
        else if (container === window) {
            window.scrollTo(nextScroll, window.pageYOffset);
        }
        else {
            container.scrollLeft = nextScroll;
        }
        if (time < duration) {
            raf(frameFunc);
        }
        else if (typeof callback === 'function') {
            callback();
        }
    };
    raf(frameFunc);
}
